import {
  type LogicalRouterSettings,
  type RouteCondition,
  useProviderStore,
} from "@versatile-credit-apply/sdk"

import routes from "./routes"

import { hasMultiplePlanLauncherProviders } from "@/composition/plan/use-plan-launcher-summaries"
import { type StepRouteMeta } from "@versatile-credit-apply/components"

declare module "vue-router" {
  interface RouteMeta {
    showPreviousDecision?: RouteCondition
    layout?: "merchantIntro" | "bgImage" | "responsiveBgImage"
    /**
     * Indicate the current "step" for the round.
     *
     * The value should be an ID of one of the steps.
     */
    step?: StepRouteMeta
    /**
     * Hides the stepper for the current route. This is typically used for pages before
     * the app form flow begins.
     */
    hideStepper?: boolean

    exitTrigger?: boolean
  }
}

const routerSettings: LogicalRouterSettings = {
  mode: "complicated",
  baseUrl: import.meta.env.BASE_URL,
  routes,
  routeConditions: {
    singleProviderOffer: () => {
      const store = useProviderStore()
      return !hasMultiplePlanLauncherProviders(store)
    },
  },
  groupRouteLoader: async (group: string) => {
    const module = await import(`@/groups/${group}`)
    return module.routes
  },
}

export default routerSettings
